import { z } from "zod/v4";
import { tournamentDetailSchema, tournamentListResponseSchema } from "../schemas/tournament";
import type { ListParams } from "./games";
import { fetchApi, toSearchParams } from "./internal";

export type TournamentsListParams = ListParams & { status?: string; federation?: string };

export const tournaments = {
	deleteDetail: (slug: string) =>
		fetchApi(
			`/admin/tournaments/${slug}/detail`,
			z.object({ message: z.string(), slug: z.string() }),
			{ method: "DELETE" },
		),
	get: (slug: string) =>
		fetchApi(`/public/directory/tournaments/${encodeURIComponent(slug)}`, tournamentDetailSchema),
	list: (params: TournamentsListParams = {}) => {
		const qs = toSearchParams(params);
		return fetchApi(
			`/public/directory/tournaments${qs ? `?${qs}` : ""}`,
			tournamentListResponseSchema,
		);
	},
	reindex: () =>
		fetchApi("/admin/tournaments/reindex", z.object({ indexed: z.number() }), {
			method: "POST",
		}),
};
